import { FC } from 'react';

interface Props {
  id: number;
  name: string;
  checked: boolean;
  onToggle: (id: number) => void;
}

export const ListChoice: FC<Props> = ({ id, name, checked, onToggle }) => {
  const toggle = () => onToggle(id);
  return (
    <label className="flex cursor-pointer items-center gap-2 rounded p-1.5 text-xs hover:bg-muted">
      <input type="checkbox" checked={checked} onChange={toggle} />
      <span className="min-w-0 break-words">{name}</span>
    </label>
  );
};
